/*
 * @Author: cn1994
 * @Date: 2023-09-14 16:09:44
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:06:30
 * @Description: file content
 */
const routes = [
  // 线索管理首页
  {
    path: "/clue",
    name: 'clue',
    meta: {
      title: '线索管理',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/salesV2/recruit.vue'),
  },
  // 线索详情
  {
    path: "/clue/detail",
    name: 'clue/detail',
    meta: {
      title: '线索详情',
      hasBack: true
    },
    component: () => import('../pages/salesV2/studentDetail.vue'),
  },
  // 线索设置
  {
    path: "/clue/setClue",
    name: 'clue/setClue',
    meta: {
      title: '线索设置',
      hasBack: true
    },
    component: () => import('../pages/salesV2/setClue.vue'),
  },
  // 跟进管理
  {
    path: "/trace",
    name: 'trace',
    meta: {
      title: '跟进管理',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/salesV2/trace.vue'),
  },
  // 新的续费预警
  {
    path: '/renewalWarning',
    name: 'renewalWarning',
    meta: {
      title: '续费预警',
      hasBack: false,
      volcengine: true,
    },
    component: () => import('../pages/sales/signupWarning/newSignupWarning.vue'),
  },
  { // 分享招生
    path: '/shareRecruitStudents',
    name: 'shareRecruitstudents',
    meta: {
      title: '分享招生',
      volcengine: true,
    },
    component: () => import('../pages/salesV2/shareRecruitStudents.vue'),
  },
];
export default routes;